import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ISortableItemProps } from "./SortableList";

/**
 * A draggable item component that can be used within a sortable list.
 * This component integrates with the dnd-kit library to enable drag and drop functionality.
 */
export const SortableItem = ({ DragHandler, children, className, id }: ISortableItemProps) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return DragHandler ? (
        <div ref={setNodeRef} style={style} className={className}>
            <DragHandler {...attributes} {...listeners} />
            {children}
        </div>
    ) : (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={className}>
            {children}
        </div>
    );
};